import { render, staticRenderFns } from "./PendingMain.vue?vue&type=template&id=858bc60e"
import script from "./PendingMain.vue?vue&type=script&lang=ts"
export * from "./PendingMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports